// extracted by mini-css-extract-plugin
export default {"root":"ProjectPage_root__m5ku0","content":"ProjectPage_content__MxUpp","item":"ProjectPage_item__v2qWL","itemContent":"ProjectPage_itemContent__+Hp4X"};